export const INCONCLUSIVE = 'Inconclusive';
export const NOT_DETECTED = 'Not Detected';
export const DETECTED = 'Detected';
export const ABOVE_RANGE = 'Above range';
export const BELOW_RANGE = 'Below range';
export const LICENSE_NUM = process.env.REACT_APP_LICENSE_NUM || '#36095-DIR-4';
export const LOW = 'low';
export const MEDIUM = 'medium';
export const HIGH = 'high';
export const NOTE = 'note';
export const DISCLAIMER = 'disclaimer';
export const CONCENTRATION_UNITS = 'ng/mL';
export const ASSUMED_ABOVE_RANGE_VALUE = parseInt(process.env.REACT_APP_PFAS_ABOVE_RANGE_ASSUMED_VALUE || '25');
export const INCONCLUSIVE_STATUS = 'inconclusive';
export const NOT_DETECTED_STATUS = 'not_detected';
export const DETECTED_STATUS = 'detected';
export const ABOVE_RANGE_STATUS = 'above_range';
export const BELOW_RANGE_STATUS = 'below_range';
export const UNKNOWN_STATUS = 'unknown';
